import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="resumin--submit-loading"
export default class extends Controller {
  static targets = ["loading", "arrow"];
  static values = {
    external: { type: Boolean, default: false },
  };

  connect() {
    this.element.addEventListener("submit", this.loading.bind(this));
    this.unloading();
  }

  disconnect() {
    this.element.removeEventListener("submit", this.loading.bind(this));
  }

  loading() {
    this.arrowTargets.forEach((arrow) => {
      arrow.style.display = "none";
    });

    this.loadingTargets.forEach((loading) => {
      loading.style.display = "block";
    });

    if (this.externalValue) {
      this._loadingExternalTarget();
    }
  }

  unloading() {
    this.arrowTargets.forEach((arrow) => {
      arrow.style.display = "block";
    });

    this.loadingTargets.forEach((loading) => {
      loading.style.display = "none";
    });

    if (this.externalValue) {
      this._unloadingExternalTarget();
    }
  }

  _loadingExternalTarget() {
    this._getExternalArrowTargets().forEach((arrow) => {
      arrow.style.display = "none";
    });

    this._getExternalLoadingTargets().forEach((loading) => {
      loading.style.display = "block";
    });
  }

  _unloadingExternalTarget() {
    this._getExternalArrowTargets().forEach((arrow) => {
      arrow.style.display = "block";
    });

    this._getExternalLoadingTargets().forEach((loading) => {
      loading.style.display = "none";
    });
  }

  _getExternalArrowTargets() {
    return document.querySelectorAll(
      "[data-resumin--submit-loading-external-target='arrow']"
    );
  }

  _getExternalLoadingTargets() {
    return document.querySelectorAll(
      "[data-resumin--submit-loading-external-target='loading']"
    );
  }
}
